export enum StatoSpedizione
{
    NUOVA = "NUOVA",
    COMPLETA = "COMPLETA",
    SPEDITA = "SPEDITA",
}